import { useState } from "react";
import { useParams } from "react-router";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce } from "../../../../utils/Utils";

interface TabReviewersServiceType {
  reviewers: any;
  expanded: number;
  changeExpand: (id: number) => void;
}

export default function TabReviewersService(): TabReviewersServiceType {
  const { showMessage } = useAppContext();

  const [reviewers, setReviewers] = useState<any>([]);
  const [expanded, setExpanded] = useState<any>();

  const { axiosGetArticleReviewers }: ArticleControllerType = ArticleController();

  const { id }: any = useParams();

  const changeExpand = (id: number) => setExpanded(id === expanded ? undefined : id);

  useEffectOnce(() => {
    getArticleById();
  });

  const getArticleById = () => {
    axiosGetArticleReviewers(id)
      .then((result: any) => {
        const revisions = result.data
          .map((item: any) => item.revision)
          .filter((value: any, index: any, self: any) => self.indexOf(value) === index);
        const dataByRevision: any = [];

        revisions.reverse().forEach((revision: number) => {
          const element = result.data.filter((x: any) => x.revision === revision);
          dataByRevision.push({
            id: revision,
            element: element,
          });
        });
        setReviewers(dataByRevision);
        setExpanded(revisions[0]);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { reviewers, expanded, changeExpand };
}

export type { TabReviewersServiceType };
